import { render, staticRenderFns } from "./chartDeliveryUnitRegion.vue?vue&type=template&id=f982c9c8&scoped=true&"
import script from "./chartDeliveryUnitRegion.vue?vue&type=script&lang=js&"
export * from "./chartDeliveryUnitRegion.vue?vue&type=script&lang=js&"
import style0 from "./chartDeliveryUnitRegion.vue?vue&type=style&index=0&id=f982c9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f982c9c8",
  null
  
)

export default component.exports